'use strict';
var app = require('angular').module('dashboard');

app.controller('dashboardUsersCtrl',  require('./dashboardUsersCtrl'));
app.config(['$stateProvider', require('./dashboardUsersConfig')]);
app.directive('inputselect', [require('../directives/inputSelectDirective')]);
